module.exports = __webpack_public_path__ + "img/Recent-Searches.b89f48d4.jpg";